<template>
  <el-checkbox-group v-model="input" class="check-container">
    <el-checkbox v-for="(item, index) in options" :label="item.no" true-label :key="index">{{ item.name }}</el-checkbox>
  </el-checkbox-group>
</template>

<script>
export default {
  name: "Checkbox",
  props: {
    value: {
      type: [String, Number, Boolean, Array],
      default: null,
    },
    options: {
      type: Array,
      default() {
        return [];
      },
    },
	isCondition: { // false-默认进入筛选条件初始化 
		type: Boolean,
		default: false
	},
  isCard: {
      // 是否是form表单
      type: Boolean,
      default: false,
    },
    field: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    filterable: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    cssstyle: {
      // 自定义样式
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      initValue: [],
      curentField: ''
    };
  },
  computed: {
    input: {
      get() {
        return this.initValue;
      },
      set(val) {
        this.initValue = val;
        let res = [];
        res = this.options.filter((item) => this.initValue.includes(+item.no))
        if (res && res.length) {
          this.$emit("click", {
            val: res.map(x => x.no),
            field: this.field,
            name: res.map(x => x.name),
            isCard: this.isCard,
			isCondition: this.isCondition
          });
        } else {
			this.$emit("click", {
            val: [],
            field: this.field,
            isCard: this.isCard,
			isCondition: this.isCondition
          });
		}
      },
    },
  },
  watch: {},
  mounted() {
	// this.initValue = this.value
	// this.$emit("initFormData", {
    //   val: this.initValue,
    //   field: this.field
    // });
    // if (this.value && this.value.length) {
      this.initValue = this.value;
      this.curentField = this.field
      const res = this.options.filter((item) => this.initValue.includes(+item.no))
      this.$emit("initFormData", {
        val: res.map(x => x.no),
        field: this.field,
        name: res.map(x => x.name),
        isCard: this.isCard,
        isCondition: this.isCondition
      });
    // }
  },
};
</script>
<style lang="scss" scoped>
.check-container {
  margin-right: 15px;
  position: relative;
  &::after {
    position: absolute;
    content: '';
    top: 1px;
    width: 1px;
    background: #E4E7ED;
    right: -15px;
    bottom: -1px;
  }
	/deep/ .el-checkbox {
		.el-checkbox__input.is-checked .el-checkbox__inner {
			background-color: #e40e1b;
			border-color: #e40e1b !important;
		}
		.el-checkbox__input.is-focus .el-checkbox__inner {
			border-color: #E4E7ED;
		}
		.el-checkbox__inner:hover {
			border-color: #e40e1b;
		}
		.el-checkbox__input.is-checked+.el-checkbox__label {
			color: #333;
		}
	} 
}
</style>
